import classNames from 'clsx';
import { IconActionChevronLeft16, IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './styles.css';

export interface IVerticalArrowProps {
  direction: -1 | 1;
  offset?: number;
  containerClass?: string;
  onClick?(): void;
}

const DEFAULT_OFFSET = -20;

export function VerticalArrow({ direction, offset = DEFAULT_OFFSET, containerClass, onClick }: IVerticalArrowProps) {
  const ArrowIcon = direction < 0 ? IconActionChevronLeft16 : IconActionChevronRight16;
  const style = direction < 0 ? { left: `${offset}px` } : { right: `${offset}px` };

  return (
    <div
      className={classNames(styles['arrow'], containerClass)}
      style={style}
      onClick={onClick}
      data-testid={`VerticalArrow-${direction}`}
    >
      <ArrowIcon color={'icon-secondary-default'} />
    </div>
  );
}
